/* ORTEVA SOMNIA — tema betiği */
(function () {
  'use strict';

  var T = window.OV_T || {};
  var LOC = T.loc || 'en';

  /* Dil ön eki: /tr, /de … Sepete ekleme ve yönlendirmeler bunu korumalı,
     aksi hâlde müşteri seçtiği dilden ana dizine düşüyor. */
  var KOK = T.root || '/';
  if (KOK.charAt(KOK.length - 1) !== '/') { KOK += '/'; }
  var URL_SEPET = T.cart || (KOK + 'cart');
  var URL_EKLE = (T.cart_add || (KOK + 'cart/add')) + '.js';
  var KOD_BAYRAK = 'ov-kapida-odeme';

  /* Fiyat biçimi mağazanın para birimi biçimiyle aynı: 1.999,00 TL */
  function para(k) {
    var n = (k / 100).toFixed(2).split('.');
    var g = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '');
    return g.split('').join('.') + ',' + n[1] + ' TL';
  }
  function iki(n) { return String(n).padStart(2, '0'); }
  function metin(k, yedek, sayi) {
    var s = T[k] || yedek;
    if (sayi !== undefined) s = String(s).replace('%N%', sayi);
    return s;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href="#urun"], [data-bm-kaydir]') : null;
    if (!a) return;
    var hedef = document.getElementById('urun');
    if (!hedef) return;
    e.preventDefault();
    hedef.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- galeri ---------- */
  var track = document.querySelector('[data-track]');
  var noktaKap = document.querySelector('[data-nokta]');
  if (track && noktaKap) {
    var slayt = track.children.length, pos = 0, w = 0, timer = null, noktalar = [];
    for (var i = 0; i < slayt; i++) (function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', metin('slide', 'Image %N%', k + 1));
      b.addEventListener('click', function () { pos = k; ciz(); basla(); });
      noktaKap.appendChild(b); noktalar.push(b);
    })(i);
    function olc() { var vp = document.querySelector('.bm-gal__vp'); if (vp) { w = vp.clientWidth; ciz(); } }
    function ciz() {
      track.style.transform = 'translateX(' + (-pos * w) + 'px)';
      noktalar.forEach(function (d, j) { d.classList.toggle('bm-aktif', j === pos); });
    }
    function ileri() { pos = (pos + 1) % slayt; ciz(); }
    function geri() { pos = (pos - 1 + slayt) % slayt; ciz(); }
    function basla() { dur(); if (slayt > 1) timer = setInterval(ileri, 4200); }
    function dur() { if (timer) { clearInterval(timer); timer = null; } }
    var sol = document.querySelector('.bm-gal__ok--sol'), sag = document.querySelector('.bm-gal__ok--sag');
    if (sol) sol.addEventListener('click', function () { geri(); basla(); });
    if (sag) sag.addEventListener('click', function () { ileri(); basla(); });
    window.addEventListener('resize', olc);
    olc(); basla();
  }

  /* ---------- satın alma kutusu ---------- */
  var kutu = document.querySelector('[data-bm-urun]');
  var karisikSecim = false;
  var sepeteEkle = null;
  if (kutu) {
    var VAR = [];
    try { VAR = JSON.parse(kutu.getAttribute('data-varyantlar') || '[]'); } catch (e) { VAR = []; }
    var ORAN = (parseFloat(kutu.getAttribute('data-indirim')) || 0) / 100;
    var harita = {}; VAR.forEach(function (v) { harita[String(v.id)] = v; });
    var taban = VAR.length ? VAR[0] : { fiyat: 0 };

    var paketler = [].slice.call(document.querySelectorAll('[data-paket]'));
    var slotlar = [].slice.call(document.querySelectorAll('[data-slot]'));
    var toplamEl = document.querySelector('[data-toplam]');
    var altbarEl = document.querySelector('[data-altbar]');
    var formId = document.querySelector('[data-bm-form-id]');
    var formAdet = document.querySelector('[data-bm-form-adet]');

    function adet() {
      var r = document.querySelector('[data-paketler] input:checked');
      return r ? parseInt(r.value, 10) : 1;
    }
    /* Shopify "1 al, 2.'si %X": pahalıdan ucuza sırala, her 2. ürün indirimli */
    function hesapla(fiyatlar) {
      var s = fiyatlar.slice().sort(function (a, b) { return b - a; }), t = 0;
      for (var i = 0; i < s.length; i++) t += (i % 2 === 1) ? Math.round(s[i] * (1 - ORAN)) : s[i];
      return t;
    }
    function topla(fiyatlar) {
      return fiyatlar.reduce(function (a, b) { return a + b; }, 0);
    }
    function secili(slot) {
      var r = slot.querySelector('[data-opt="0"] input:checked');
      return r ? harita[r.value] : null;
    }
    /* Kazanç her zaman "ayrı ayrı alsaydınız" tutarına göre — tavsiye fiyatına göre değil */
    function rozet(el, normal, indirimli) {
      if (!el) return;
      if (normal > indirimli) { el.textContent = para(normal - indirimli) + ' ' + metin('save', 'saved'); el.hidden = false; }
      else { el.hidden = true; }
    }
    function paketKartlari() {
      paketler.forEach(function (p) {
        var n = parseInt(p.getAttribute('data-paket'), 10);
        var f = [];
        for (var i = 0; i < n; i++) f.push(taban.fiyat);
        var t = hesapla(f), normal = topla(f);
        var tu = p.querySelector('[data-paket-tutar]'), es = p.querySelector('[data-paket-eski]');
        if (tu) tu.textContent = para(t);
        if (es) { if (normal > t) { es.textContent = para(normal); es.hidden = false; } else { es.hidden = true; } }
        rozet(p.querySelector('[data-paket-kazanc]'), normal, t);
      });
    }
    function guncelle() {
      var n = adet(), fiyatlar = [], secimler = [];
      paketler.forEach(function (p) { p.classList.toggle('bm-secili', p.querySelector('input').checked); });
      slotlar.forEach(function (s, i) {
        if (i < n) { s.removeAttribute('hidden'); } else { s.setAttribute('hidden', ''); }
        var v = secili(s);
        var ozet = s.querySelector('[data-ozet]');
        if (ozet) ozet.textContent = v ? '· ' + v.ad : '';
        if (i < n && v) { fiyatlar.push(v.fiyat); secimler.push(String(v.id)); }
      });
      var t = hesapla(fiyatlar), normal = topla(fiyatlar);
      if (toplamEl) toplamEl.textContent = para(t);
      if (altbarEl) {
        altbarEl.textContent = para(t);
        var s2 = altbarEl.parentNode.querySelector('s');
        if (s2) { if (normal > t) { s2.textContent = para(normal); s2.hidden = false; } else { s2.hidden = true; } }
      }
      /* Kapıda ödeme uygulaması gizli form alanlarını okuyor — seçimle eşitle */
      karisikSecim = false;
      for (var j = 1; j < secimler.length; j++) {
        if (secimler[j] !== secimler[0]) { karisikSecim = true; break; }
      }
      if (formId && secimler.length) { formId.value = secimler[0]; }
      if (formAdet) { formAdet.value = String(n); }
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-paketler]') || e.target.closest('[data-slotlar]')) guncelle();
    });
    paketKartlari(); guncelle();

    function kalemler() {
      var n = adet(), sayac = {};
      slotlar.slice(0, n).forEach(function (s) {
        var v = secili(s);
        if (v) sayac[v.id] = (sayac[v.id] || 0) + 1;
      });
      return Object.keys(sayac).map(function (id) { return { id: parseInt(id, 10), quantity: sayac[id] }; });
    }
    function ekle(btn) {
      var kalem = kalemler();
      if (!kalem.length) return;
      var eskiMetin = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = metin('adding', 'Adding to cart…'); }
      fetch(URL_EKLE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: kalem })
      }).then(function (r) {
        if (!r.ok) throw new Error('sepet');
        /* Sepet sayfasında kapıda ödeme formu gerçek sepeti okur — paketteki
           farklı renkler de doğru gider. Bayrak, formu orada kendiliğinden açmak için. */
        try { sessionStorage.setItem(KOD_BAYRAK, '1'); } catch (e) {}
        window.location.href = URL_SEPET;
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = eskiMetin; }
        var uyari = document.querySelector('[data-bm-al-alt]');
        if (uyari) uyari.textContent = metin('err', 'Something went wrong, please try again.');
      });
    }
    sepeteEkle = ekle;
    document.querySelectorAll('[data-bm-al], .bm-altbar__btn').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); ekle(b); });
    });
  }

  /* ---------- kapıda ödeme düğmesi ---------- */
  /* Tek renk seçildiyse uygulama gizli form alanlarını okuyup formu kendisi açar.
     Pakette farklı renkler varsa tek satırlık form bunu taşıyamaz; bu durumda
     paketi sepete ekleyip sepet sayfasındaki forma götürüyoruz. */
  document.addEventListener('click', function (e) {
    if (!karisikSecim || !sepeteEkle) return;
    var b = e.target.closest ? e.target.closest('.es-popup-button, .es-sticky-product') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    sepeteEkle(null);
  }, true);

  /* ---------- sepete gelince kapıda ödeme formunu kendiliğinden aç ---------- */
  (function () {
    var bayrak = null;
    try { bayrak = sessionStorage.getItem(KOD_BAYRAK); } catch (e) {}
    if (!bayrak) return;
    try { sessionStorage.removeItem(KOD_BAYRAK); } catch (e) {}
    var bitis = Date.now() + 15000;
    var sayac = setInterval(function () {
      var b = document.querySelector('.es-popup-button-cart, .es-popup-button, .es-sticky-cart');
      if (b && b.offsetParent !== null) {
        clearInterval(sayac);
        b.click();
      } else if (Date.now() > bitis) {
        clearInterval(sayac);
      }
    }, 200);
  })();

  /* ---------- yorumları genişlet ---------- */
  var revBtn = document.querySelector('[data-rev-daha]');
  var revGrid = document.querySelector('[data-rev-grid]');
  if (revBtn && revGrid) {
    var gizliSayi = revGrid.querySelectorAll('.bm-rev__kart--gizli').length;
    var toplamSayi = revGrid.querySelectorAll('.bm-rev__kart').length;
    revBtn.textContent = metin('more', 'Show all reviews (%N%)', toplamSayi);
    revBtn.addEventListener('click', function () {
      var acik = revGrid.classList.toggle('bm-rev__grid--acik');
      revBtn.textContent = acik ? metin('less', 'Show less') : metin('more', 'Show all reviews (%N%)', toplamSayi);
      if (!acik) revGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    if (!gizliSayi) revBtn.hidden = true;
  }

  /* ---------- geri sayım: SADECE gerçek kampanya bitiş tarihi varsa ---------- */
  var bitisSn = parseInt(T.deadline, 10) || 0;
  if (bitisSn > 0) {
    var GUN = { tr: 'g', de: 'T', fr: 'j', ar: 'ي' }[LOC] || 'd';
    var bitisMs = bitisSn * 1000;
    var tikla = function () {
      var k = Math.max(0, Math.floor((bitisMs - Date.now()) / 1000));
      var g = Math.floor(k / 86400);
      var s = Math.floor(k % 86400 / 3600), d = Math.floor(k % 3600 / 60), sn = k % 60;
      var saatToplam = Math.floor(k / 3600);
      var geri = document.querySelector('[data-geri]');
      if (geri) {
        geri.textContent = (g > 0 ? g + GUN + ' ' : '') + iki(g > 0 ? s : saatToplam) + ':' + iki(d) + ':' + iki(sn);
      }
      document.querySelectorAll('[data-sayac]').forEach(function (c) {
        var a = c.querySelector('[data-u="s"]'), b = c.querySelector('[data-u="d"]'), d2 = c.querySelector('[data-u="sn"]');
        if (a) a.textContent = g > 0 ? String(saatToplam) : iki(s);
        if (b) b.textContent = iki(d);
        if (d2) d2.textContent = iki(sn);
      });
      if (k === 0) {
        document.querySelectorAll('.bm-sayac, .bm-cta__sayac').forEach(function (el) { el.hidden = true; });
      }
    };
    tikla(); setInterval(tikla, 1000);
  }

  document.querySelectorAll('img').forEach(function (im) {
    im.addEventListener('error', function () { im.classList.add('bm-img--yok'); });
  });
})();
